var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityRelate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "relate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16c0-1.078-0.265-2.087-0.702-3h-2.323c0.635 0.838 1.026 1.87 1.026 3s-0.391 2.162-1.025 3c-0.67 0.885-1.62 1.536-2.725 1.823-0.402 0.105-0.816 0.177-1.25 0.177h-6.75c-2.757 0-5-2.242-5-5s2.243-5 5-5h1.774c0.515-0.768 1.169-1.424 1.89-2h-3.663c-3.859 0-7 3.141-7 7s3.141 7 7 7h6.75c0.428 0 0.843-0.052 1.25-0.126 1.4-0.254 2.655-0.918 3.633-1.874 0.586-0.572 1.057-1.253 1.414-2 0.437-0.913 0.702-1.922 0.702-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9h-6.75c-0.428 0-0.843 0.052-1.25 0.126-1.4 0.254-2.655 0.918-3.633 1.874-0.586 0.572-1.057 1.253-1.414 2-0.437 0.913-0.702 1.922-0.702 3s0.265 2.087 0.702 3h2.323c-0.634-0.838-1.025-1.87-1.025-3s0.391-2.162 1.026-3c0.67-0.885 1.62-1.535 2.724-1.822 0.402-0.104 0.816-0.178 1.25-0.178h6.75c2.757 0 5 2.243 5 5s-2.243 5-5 5h-1.774c-0.515 0.768-1.169 1.424-1.89 2h3.663c3.859 0 7-3.141 7-7s-3.141-7-7-7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityRelate);
export default __webpack_public_path__ + "static/media/unity_relate.5d50259722255c18872050ebe972ae53.svg";
export { ForwardRef as ReactComponent };